import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const TimeIcon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13 6.5C13 5.94771 12.5523 5.5 12 5.5C11.4477 5.5 11 5.94771 11 6.5L11 12C11 12.5523 11.4477 13 12 13L16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11L13 11L13 6.5Z"
    fill="currentColor"
  />,
  "TimeIcon"
);
